import {AbstractCommand} from "./abstract.command";
import {CommandName} from "./command-name.enum";

/**
 * The payload the backend reads. `uid` here is the NEW PAGE's uid — it is not
 * the envelope's own `uid`, which identifies the command and is generated by
 * the base class. The two live at different levels and collide only in name.
 */
export interface CreateLinkviewPayload {
    readonly uid: string;
    readonly title: string;
    /** The board's sidebar icon key (`LINKVIEW_ICON_KEYS`). */
    readonly icon: string | null;
}

/**
 * Creates a Linkboard page. Sent ALONE and immediately from its own dialog, not
 * inside the save bulk — the page must exist before any tile can name it as a
 * parent.
 *
 * The uid is minted here, on the client, in transport (ShortId) spelling; the
 * server never generates one.
 */
export class CreateLinkviewCommand extends AbstractCommand<CreateLinkviewPayload> {

    public name = CommandName.CREATE_LINKVIEW;

    public tags: string[] = [`entity`, `create`, `linkview`];

    constructor(payload: CreateLinkviewPayload) {
        super('linkview', payload.uid, payload);
    }
}
